import React from 'react';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import ForgotPasswordForm from './ForgotPasswordForm';

/**
 * Authentication Modal Component
 * Handles display of sign in, sign up, and password reset forms
 *
 * Epic 1.1.1: User Registration & Authentication
 */
export default function AuthModal({
  showModal,
  onClose,
  authMode,
  setAuthMode
}) {
  if (!showModal) {return null;}

  const getTitle = () => {
    switch (authMode) {
      case 'forgot':
        return 'Reset your password';
      case 'signin':
        return 'Welcome back';
      case 'signup':
        return 'Welcome to Outdoor Guides';
      default:
        return 'Welcome';
    }
  };

  const getSubtitle = () => {
    switch (authMode) {
      case 'forgot':
        return "Enter your email and we'll send you instructions to reset your password";
      case 'signin':
        return 'Sign in to your account';
      case 'signup':
        return 'Create your account to get started';
      default:
        return '';
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-start sm:items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl max-w-md w-full my-8 sm:my-0 relative">
        <div className="p-6 sm:p-8 max-h-[85vh] overflow-y-auto">
          <button
            onClick={onClose}
            className="sticky top-0 float-right p-2 hover:bg-gray-100 rounded-full transition z-10 bg-white"
            aria-label="Close modal"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <h2 className="text-2xl font-semibold mb-2">
            {getTitle()}
          </h2>
          <p className="text-gray-600 mb-6">
            {getSubtitle()}
          </p>

          {authMode === 'forgot' && (
            <ForgotPasswordForm setAuthMode={setAuthMode} />
          )}

          {authMode === 'signin' && (
            <SignInForm setAuthMode={setAuthMode} onSuccess={onClose} />
          )}

          {authMode === 'signup' && (
            <SignUpForm setAuthMode={setAuthMode} onSuccess={onClose} />
          )}
        </div>
      </div>
    </div>
  );
}
